export default __webpack_public_path__ + "static/media/catchme.a5002c7f.png";